/* eslint-disable @typescript-eslint/no-explicit-any */
import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {map, Observable} from 'rxjs';
import {FreeSlots} from 'src/shared/models/free-slots.interface';
import {OpenedDayAroundCurrentDay} from 'src/shared/models/opened-day-around-current-day';
import {OrderPlanning, OrderPlanningWithStatusCategory} from 'src/shared/models/order-planning.interface';
import {dateToFormatYearMonthDay, getLocalDateString} from 'src/shared/utils/date.utils';
import {environment} from '../environments/environment';
import {Planning} from '../../models/planning.interface';
import {LoadingStatusTruck} from '../../../shared/models/loading-status-truck.enum';
import {StatusCategory} from '../../../shared/models/status-category.enum';
import {AppointmentStatus} from '../../../shared/models/appointment-status.enum';

@Injectable()
export class PlanningService {
  url: string = `${environment.backend_url}/api/v1/planning`;

  constructor(private readonly http: HttpClient) {}

  getPlanning(): Observable<Planning> {
    return this.http.get<Planning>(`${this.url}`);
  }

  getPreviousAndNextOpenedDay(
    currentDay: moment.Moment,
  ): Observable<OpenedDayAroundCurrentDay> {
    const dateFormatted = dateToFormatYearMonthDay(currentDay);
    return this.http.get<OpenedDayAroundCurrentDay>(
      `${this.url}/get-open-days?currentDay=${dateFormatted}`,
    );
  }

  getPlanningOrders(day: Date): Observable<OrderPlanningWithStatusCategory[]> {
    const dateFormatted = getLocalDateString(day);
    return this.http.get<OrderPlanningWithStatusCategory[]>(
      `${this.url}?day=${dateFormatted}`,
    ).pipe(
      map(orders =>
        orders.map(this.categorize))
      )
  };
  

  categorize(order: OrderPlanning): OrderPlanningWithStatusCategory {
    let statusCategory: StatusCategory;
    if (order.appointmentStatus === AppointmentStatus.CANCELED) {
      statusCategory = StatusCategory.CANCELED;
    } else if (order.loadingStatusTruck === LoadingStatusTruck.LOAD_END) {
      statusCategory = StatusCategory.LOADED;
    } else {
      // LOAD_INIT, LOAD_START ou null
      statusCategory = StatusCategory.REMAINING;
    }
    return { ...order, statusCategory: statusCategory };
  }
  

  deprecatedGetPlanningOrders(
    day: Date,
    macroSlotId: string,
  ): Observable<OrderPlanning[]> {
    return this.http.get<OrderPlanning[]>(
      `${this.url}?day=${day.toISOString().split('T')[0]}&macroslotId=${macroSlotId}`,
    );
  }

  getFreeSlots(day: Date, macroSlotId: string): Observable<FreeSlots> {
    return this.http.get<FreeSlots>(
      `${this.url}/get-free-slots-count?day=${day.toISOString().split('T')[0]}&macroslotId=${macroSlotId}`,
    );
  }
  getTotalFreeSlots(day: Date): Observable<FreeSlots> {
    return this.http.get<FreeSlots>(
      `${this.url}/get-total-free-slots-count?day=${day.toISOString().split('T')[0]}`,
    );
  }
}
